import { origemLancamentoCadastroSogivendas } from '../../../models/origem-lancamento-cadastro';
import { Pessoa } from '../pessoa';
import { Representante } from './representante';

export class RepresentanteSearchRepresentante {
    id: number;
    idPessoa: number;
    codigoIntegracaoErp: string;
    cnpjCpf: string;
    nome: string;
    nomeFantasia: string;
    situacao: number;
    modalidadeComercial: number;
    integradoErp: boolean;

    quantidadeProspects: number;
    quantidadeClientes: number;
    quantidadeClientesNovos: number;
    quantidadeClientesPositivos: number;
    quantidadeClientesAtivos: number;
    quantidadeClientesPreInativos: number;
    quantidadeClientesInativos: number;
    quantidadeClientesCongelados: number;
    quantidadeClientesBloqueados: number;
}

/** Cria um novo representante */
export function representanteSearchRepresentanteToRepresentante(representanteSearch: RepresentanteSearchRepresentante): Representante {
    const representante = new Representante(origemLancamentoCadastroSogivendas);
    representante.id = representanteSearch.id;
    representante.idPessoa = representanteSearch.idPessoa;
    representante.pessoa = new Pessoa(origemLancamentoCadastroSogivendas);
    representante.pessoa.id = representanteSearch.idPessoa;
    representante.pessoa.codigoIntegracaoErp = representanteSearch.codigoIntegracaoErp;
    representante.pessoa.cnpjCpf = representanteSearch.cnpjCpf;
    representante.pessoa.nome = representanteSearch.nome;
    representante.pessoa.nomeFantasia = representanteSearch.nomeFantasia;
    representante.situacao = representanteSearch.situacao;
    representante.modalidadeComercial = representanteSearch.modalidadeComercial;

    return representante;
}

export class RepresentanteSearchTotal {
    quantidadeRepresentantes: number;
    quantidadeProspects: number;
    quantidadeClientes: number;
    quantidadeClientesNovos: number;
    quantidadeClientesPositivos: number;
    quantidadeClientesAtivos: number;
    quantidadeClientesPreInativos: number;
    quantidadeClientesInativos: number;
    quantidadeClientesCongelados: number;
    quantidadeClientesBloqueados: number;
}

export class RepresentanteSearch {
    representantes: RepresentanteSearchRepresentante[];
    total: RepresentanteSearchTotal;
}
